.BackButton {
  a, button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border: 1px solid transparent;
    transition: all .3s ease;
    background: none;
    border-radius: 9999px;

    svg {
      color: var(--primitives-colors-neutral-0);
      width: 24px;
      height: 24px;
    }

    &:hover,
    &:active,
    &:focus {
      background: var(--primitives-colors-neutral-970);
    }
  }
}